import { render, staticRenderFns } from "./CommentAdd.vue?vue&type=template&id=6fad35b6&scoped=true&lang=pug&"
import script from "./CommentAdd.vue?vue&type=script&lang=coffee&"
export * from "./CommentAdd.vue?vue&type=script&lang=coffee&"
import style0 from "./CommentAdd.vue?vue&type=style&index=0&id=6fad35b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad35b6",
  null
  
)

export default component.exports